import { FC, useMemo } from 'react'
import type { UniversalCardProps } from 'pages/account/components/deposit-card/universal-card/types'
import cn from 'classnames'
import DepositCard from 'pages/account/components/deposit-card'

import { ELoanStatuses } from '../../../../../store/fetchers/loans/enum'

import Tooltip from '../../../../../components/global/tooltip'

import { floorNumber } from '../../../../../utils/floor-number'

import { formatNumber } from '../../../../../utils/formatters'

import styles from './styles.module.scss'
import useWindowWidth from 'hooks/use-window-width'

export const UniversalCard: FC<UniversalCardProps> = ({
  columns,
  onTrackClick,
  amountCell,
  regularCell,
  statusCell,
  chartCell,
  currencyCell,
  loan,
  saving,
}) => {
  const width = useWindowWidth()

  const isSMDesktop = useMemo(() => width < 1512 && width >= 1206, [width])

  return (
    <DepositCard.Container columns={columns} onClick={onTrackClick} loan={loan} saving={saving}>
      {amountCell && (
        <DepositCard.AmountCell
          amount={amountCell.amount}
          additionalAmount={amountCell.additionalAmount}
          ticker={amountCell.ticker}
          network={amountCell.network}
          className={amountCell.className}
          loan={loan}
        />
      )}

      {currencyCell && <DepositCard.CurrencyCell ticker={currencyCell.ticker} network={currencyCell.network} />}

      {regularCell &&
        regularCell.length &&
        regularCell.map((info) => (
          <DepositCard.Cell
            key={`${info.key}${info.mainText}${info.secondaryText}`}
            className={cn(styles.column, info.date && styles.dateColumn, info.className, {
              [styles.gray]: loan?.status === ELoanStatuses.CLOSED || loan?.status === ELoanStatuses.LIQUIDATED,
              [styles.red]:
                loan?.current_zone !== null &&
                loan?.current_zone <= 0 &&
                loan?.status !== ELoanStatuses.CLOSED &&
                loan?.status !== ELoanStatuses.LIQUIDATED,
            })}
          >
            <p>{info.mainText && info.mainText.length > (isSMDesktop ? 8 : 12) ? info.mainText.slice(0, isSMDesktop ? 8 : 12) + '...' : info.mainText}</p>
            {info.mainText.length > (isSMDesktop ? 8 : 12) && (
              <Tooltip className={styles.tooltip}>
                {isNaN(Number(info.mainText.replace(/\s/g, '')))
                  ? info.mainText
                  : formatNumber(floorNumber(Number(info.mainText.replace(/\s/g, '')), 6))}
              </Tooltip>
            )}
            <span
              className={cn(
                styles.secondaryDescription,
                { [styles.secondaryDescription__greenText]: info.greenText },
                { [styles.secondaryDescription__redText]: info.redText },
              )}
            >
              {info.secondaryText}
              <p className={cn(styles.secondaryDescription, styles.secondaryDescription__additional)}>
                {info.additionalSecondaryText}
              </p>
            </span>
          </DepositCard.Cell>
        ))}

      {chartCell && (
        <DepositCard.ChartCell
          className={chartCell.className}
          currency={chartCell.currency}
          period={chartCell.period}
          color={chartCell.color}
        />
      )}

      {statusCell && statusCell.status && (
        <DepositCard.StatusCell
          status={statusCell.status}
          id={statusCell.id}
          createdAt={statusCell.createdAt}
          loan={loan}
          className={
            statusCell.status.toLowerCase() === 'failed'
              ? `${styles.active}`
              : `${styles[statusCell.status.toLowerCase()]}`
          }
          isLoans={statusCell.isLoans}
        />
      )}
    </DepositCard.Container>
  )
}
